import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

/**
 * DOM access for the shared login-history modal (profile page "Last login"
 * button). Exactly one instance per page, so this queries `document` rather
 * than a scoped root — mirrors FacebookCustomerChat/MessengerLink's single-
 * instance convention, not UsersAdminForm's multi-root pattern (that one is
 * a separate, independent instance scoped to the admin users-list page).
 */
export class LoginHistoryForm extends FormBase {
    public getTriggerButtons(): HTMLButtonElement[] {
        return this.queryElements(document, `[data-role="${Roles.LOGIN_HISTORY_TRIGGER}"]`, HTMLButtonElement);
    }

    public getModal(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL}"]`, HTMLElement);
    }

    public getOverlay(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getCloseButtons(): HTMLElement[] {
        return this.queryElements(document, `[data-role="${Roles.CLOSE_LOGIN_HISTORY_MODAL}"]`, HTMLElement);
    }

    public getTitleEl(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL_TITLE}"]`, HTMLElement);
    }

    public getStatusEl(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL_STATUS}"]`, HTMLElement);
    }

    public getSpinnerEl(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL_SPINNER}"]`, HTMLElement);
    }

    public getBodyEl(): HTMLElement | null {
        return this.queryElement(document, `[data-role="${Roles.LOGIN_HISTORY_MODAL_BODY}"]`, HTMLElement);
    }
}
